import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchToken } from "../thunk/LoginThunk";

const initialData: any = [];

const initialState = {
  data: initialData,
  isLoading: false,
  error: "",
};

const LoginChartSlice = createSlice({
  name: "LoginChartSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchToken.pending, (state) => {
      state.isLoading = true;
      state.error = "";
    });

    builder.addCase(fetchToken.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = {
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        expiresIn: action.payload.expiresIn
      };
    });

    builder.addCase(fetchToken.rejected, (state, action) => {
      state.isLoading = false;
      let errorMessage = "Login failed";
      
      if (action.payload) {
        if (typeof action.payload === "string") {
          errorMessage = action.payload;
        } else if (typeof action.payload === "object") {
          const payload = action.payload as any;
          errorMessage = payload.message || 
                        payload.error || 
                        payload.data?.message || 
                        payload.data?.error ||
                        JSON.stringify(payload);
        }
      } else if (action.error?.message) {
        errorMessage = action.error.message;
      }
      
      console.log("LoginChartSlice - final errorMessage:", errorMessage);
      
      state.error = errorMessage;
      state.data = errorMessage;
    });
  },
});


export default LoginChartSlice
